(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ModelEquationDeleteController',ModelEquationDeleteController);

    ModelEquationDeleteController.$inject = ['$uibModalInstance', 'entity', 'ModelEquation'];

    function ModelEquationDeleteController($uibModalInstance, entity, ModelEquation) {
        var vm = this;

        vm.modelEquation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ModelEquation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
